export { View as MoneyForBusiness } from './view'
